import '@babel/polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import LogRocket from 'logrocket'

import Laraform from '@laraform/laraform'
import './main.css'

if ('Notification' in window) {
  console.log('Notification Permission', Notification.permission)
}

import * as PusherPushNotifications from '@pusher/push-notifications-web'

if (process.env.VUE_APP_ENV != 'local') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_ENV,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    release: window.version
  })

  LogRocket.init(process.env.VUE_APP_LOGROCKET_PROJECT)
  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra('sessionURL', sessionURL)
    })
  })
}
import './plugins/vuetify'
import './plugins/axios'
// import './registerServiceWorker'
import App from './App.vue'
import router from './router'
import store from './store/index'
import { Settings } from 'luxon'
Settings.defaultZoneName = 'Europe/London'

window.navigator.serviceWorker.ready.then(serviceWorkerRegistration => {
  console.log('Servicde Worker Ready')
  window.beamsClient = new PusherPushNotifications.Client({
    instanceId: process.env.VUE_APP_PUSH_INSTANCE_ID,
    serviceWorkerRegistration: serviceWorkerRegistration
  })
  serviceWorkerRegistration.active.postMessage({ type: 'get-version' })
  const channel = new BroadcastChannel('sw-messages')
  console.log('Registered for channel', channel)
  channel.addEventListener('message', event => {
    console.log('Version: ', event.data.version)
    store.commit('root/SET_APP_VERSION', event.data.version)
  })
})

import VueAnalytics from 'vue-analytics'
// and then use it in main.js
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_CODE,
  router
})

import VueOnlinePlugin from 'vue-navigator-online'

Vue.use(VueOnlinePlugin)

window._ = require('lodash')

Vue.config.productionTip = false

/* import axios from 'axios'

Vue.use(axios)*/

// import offline from './store/offline/index'

// Add service worker register after firebase initialised
import './registerServiceWorker'

window.addEventListener('load', function() {
  async function updateOnlineStatus(event) {
    if (navigator.onLine) {
      // handle online status
      // re-try api calls
      console.log('device is now online')
      const registration = await navigator.serviceWorker.ready
      await registration.sync.register('offline-requests')
      registration.active.postMessage({ type: 'get-version' })
    } else {
      // handle offline status
      console.log('device is now offline')
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.controller.postMessage({
        online: navigator.onLine
      })
    }
  }
  window.addEventListener('online', updateOnlineStatus)
  window.addEventListener('offline', updateOnlineStatus)
})

Laraform.store(store)

let app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
